<script lang="ts">
  // Figma file with the graphics: https://www.figma.com/file/lD0pD1QCfqSxcDb3cjpBPA/Number-plate-graphics?type=design&node-id=0%3A1&mode=design&t=sqwLrnBQQPAJmXm6-1
  // Initial graphics are downloaded from Wikipedia
  import dkLpn from "../../shared/assets/numberPlateDk.svg?raw"
  import seLpn from "../../shared/assets/numberPlateSe.svg?raw"
  import gbLpn from "../../shared/assets/numberPlateGb.svg?raw"
  import nlLpn from "../../shared/assets/numberPlateNl.svg?raw"
  import itLpn from "../../shared/assets/numberPlateIt.svg?raw"

  export let placeholder: string
  export let lpnNumber: string
  // Defined in TradeInValuationsHelper#license_plate_input_country
  export let licensePlateCountry: "DK" | "SE" | "GB" | "NL" | "I"
  export let style = ""

  let focused: boolean

  /**
   * Due to webpack configurations, we are not able to use resolve the image path in CSS
   * so we need to import the image as a SVG string, convert it to a base64 format,
   * then use that in the background-image inline style of the input
   *
   * FIXME: This should be rewritten perhaps to use the Svg component that floats on top of the input
   */
  const lpnImage =
    licensePlateCountry === "DK"
      ? btoa(dkLpn)
      : licensePlateCountry === "SE"
      ? btoa(seLpn)
      : licensePlateCountry === "GB"
      ? btoa(gbLpn)
      : licensePlateCountry === "NL"
      ? btoa(nlLpn)
      : licensePlateCountry === "I"
      ? btoa(itLpn)
      : ""
</script>

<!--
@component
Shows a text input of the LPN and it's rendered on Legacy Prompt a.k.a DCTA
-->

<div class="auws-lpn-input-container">
  <input
    type="text"
    class={`auws-lpn-input ${licensePlateCountry.toLowerCase()}`}
    data-testid="legacy-input"
    style={`${style} background-image: url('data:image/svg+xml;base64,${lpnImage}');`}
    bind:value={lpnNumber}
    on:keydown
    on:focus={() => (focused = true)}
    on:blur={() => (focused = false)}
  />
  <!-- Using a separate element as placeholder to achieve consistent styles in e.g. Safari -->
  {#if !focused && !lpnNumber}
    <div class="auws-lpn-input-placeholder">
      {placeholder}
    </div>
  {/if}
</div>

<style>
  .auws-lpn-input-container {
    position: relative;
    margin-bottom: 6px;
    background: #fff;
    height: 55px;
  }

  input {
    padding: 0 15px;
    font-size: 40px;
    font-weight: 500;
    line-height: 55px;
    height: 55px;
    width: 100%;
    text-align: center;
    text-transform: uppercase;
    box-sizing: border-box;
    color: #515c5e;
    border-radius: 5px;
    transition: all 0.35s;
    z-index: 10;
    position: relative;
    margin-bottom: 0px;
    padding-left: 35px;
    background-repeat: no-repeat;
    background-color: transparent;
    background-position: 0 50%;
    background-size: auto 60px;
    border: 3px solid #000;
  }

  .auws-lpn-input.dk {
    border-color: #ef5350;
  }

  .auws-lpn-input-container {
    position: relative;
    margin-bottom: 6px;
    background: #fff;
    height: 55px;
  }

  .auws-lpn-input-placeholder {
    color: rgba(0, 0, 0, 0.35);
    pointer-events: none;
    font-size: 18px;
    position: absolute;
    text-transform: uppercase;
    text-align: center;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10;
  }
</style>
